import React from 'react';
import {IconButton, List, makeStyles, Typography,} from "@material-ui/core";
import Song from "../SongQueue/Song";
import SongActionButton from "./SongActionButton";
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import ThumbUpOutlinedIcon from '@material-ui/icons/ThumbUpOutlined';
import {getState} from "../../../controllers/stateController";

const useStyles = makeStyles((theme) => ({
    iconButton: {
        color: "white",
    },
    voting: {
        display: "flex",
        alignItems: "center"
    },
    count: {
        marginRight: theme.spacing(2)
    }
}))



function VotingQueue( {queue, handleVote, hasVotedAlready, handleRemove} ) {
    const classes = useStyles();

    return (
        <List dense={true}>
            {Object.entries(queue).map((e) => (e[1])).sort(function(a, b) {
                if(a.votes === b.votes) {
                    if(a.timestamp !== undefined && b.timestamp !== undefined) {
                        return a.timestamp.seconds - b.timestamp.seconds
                    }
                    else {
                        return 0
                    }
                }
                return b.votes - a.votes;
            }).map(song => {
                return (
                    <Song track={song} key={song.title} action={getState().role === "host"
                        ? <SongActionButton
                            handleVote={(e) => handleVote(e)}
                            song={song}
                            hasVotedAlready={e => hasVotedAlready(e, false)}
                            handleRemove={(s) => handleRemove(s)}
                        />
                        : <IconButton
                            aria-label="vote"
                            onClick={() => handleVote(song)}
                            color="primary"
                            classes={{
                                colorPrimary: classes.iconButton
                            }}
                        >
                            <div className={classes.voting}>
                                <Typography variant="h6" color="initial" className={classes.count}>
                                    <b>{song.votes}</b>
                                </Typography>
                                {hasVotedAlready(song, false) ? <ThumbUpOutlinedIcon/> : <ThumbUpIcon/>}
                            </div>
                        </IconButton>}
                    />
                )
            })}
        </List>
    );
}

export default VotingQueue
